import { Breadcrumb, BreadcrumbIcon, BreadcrumbLink, BreadcrumbPage } from '@ads/components-react';
import { createFileRoute, Link, useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { SerieLangForm } from '@/features/series-lang-management';
import { PageHeader } from '@/shared/ui/organisms/PageHeader';

export const Route = createFileRoute('/_authenticated/series/$serieId/langs/create/')({
  component: SerieLangCreatePage,
});

/** Página de criação de Idioma da Série. */
export function SerieLangCreatePage() {
  const { t } = useTranslation('series');
  const { serieId: serieIdParam } = Route.useParams();
  const serieId = Number(serieIdParam);
  const navigate = useNavigate();

  const goBack = () =>
    void navigate({ to: '/series/$serieId/langs', params: { serieId: serieIdParam } });

  return (
    <div className="flex flex-col gap-mini">
      <PageHeader
        title={t('langs.form.createTitle')}
        breadcrumb={
          <Breadcrumb>
            <BreadcrumbLink>
              <Link to="/">
                <BreadcrumbIcon />
              </Link>
            </BreadcrumbLink>
            <BreadcrumbLink>
              <Link to="/series">{t('langs.breadcrumb.series')}</Link>
            </BreadcrumbLink>
            <BreadcrumbLink>
              <Link to="/series/$serieId/langs" params={{ serieId: serieIdParam }}>
                {t('langs.breadcrumb.langs')}
              </Link>
            </BreadcrumbLink>
            <BreadcrumbPage>{t('langs.form.createTitle')}</BreadcrumbPage>
          </Breadcrumb>
        }
      />

      <SerieLangForm serieId={serieId} lang={null} onSaved={goBack} onCancel={goBack} />
    </div>
  );
}
